// extracted by mini-css-extract-plugin
export var quantityInput = "_f7-0";